import * as React from "react";
import Image from "next/image";
import Marquee from "react-marquee-slider";
import styles from "./styles.module.scss";
import bgImg from "../../../../public/images/t19bg.png";
import { MemoMessageModal as MessageModal } from "../../modals/MessageModal";
import Dialog from "../../Dialog";
import { useQuery } from "@apollo/client";
import {
  EventBySlugQuery,
  GetApprovedMessagesQuery,
  GetApprovedMessagesQueryVariables,
} from "@src/@types/api.d";
import { GetApprovedMessages } from "@src/graphql/queries";
import { getCookie } from "cookies-next";
import Icon from "@src/components/Icon";

// Toggle this to true during development to show hardcoded messages
const design_mode = false;

const hardcodedMessages = [
  { content: "To love, laughter, and happily ever after!" },
  { content: "A toast to a lifetime of memories!" },
  { content: "So glad to share in your special day." },
  { content: "Wishing you endless joy and romance!" },
  { content: "You two are perfect together!" },
];

type Props = {
  eventId: number;
  slugData: EventBySlugQuery | undefined;
};

const MarqueeComp: React.FC<Props> = ({ slugData, eventId }) => {
  const [open, setOpen] = React.useState<boolean>(false);
  const [show, setShow] = React.useState<boolean>(false);
  const currentAccessToken = getCookie("tsl") as string;
  const [isMarqueePaused, setIsMarqueePaused] = React.useState(false);

  const pauseMarquee = () => setIsMarqueePaused(true);
  const resumeMarquee = () => setIsMarqueePaused(false);

  React.useEffect(() => {
    setShow(true);
  }, []);

  const { data: getApprovedMessagesData } = useQuery<
    GetApprovedMessagesQuery,
    GetApprovedMessagesQueryVariables
  >(GetApprovedMessages, {
    skip: !eventId || design_mode,
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    variables: { eventId },
    pollInterval: 1000 * 10,
  });

  const messages = design_mode
    ? hardcodedMessages
    : getApprovedMessagesData?.getApprovedMessages ?? [];

  return messages.length > 0 ? (
    <section className="py-2 relative overflow-hidden">
      <div className="absolute inset-0">
        <Image
          src={bgImg}
          alt="background"
          layout="fill"
          className="object-cover object-center"
        />
      </div>
      <div className="relative z-10">
        <div
          className={styles["home__marquee"]}
          onMouseEnter={pauseMarquee}
          onMouseLeave={resumeMarquee}
          onClick={pauseMarquee}
        >
          {/* First Marquee Row */}
          <div style={{ height: "250px", maxWidth: "100vw", width: "100%" }}>
            <Marquee
              velocity={isMarqueePaused ? 0 : 40}
              direction="rtl"
              scatterRandomly={false}
              resetAfterTries={200}
              onInit={() => null}
              onFinish={() => null}
            >
              {messages
                .filter((_, i) => i % 2 === 0)
                .map((item, index) => (
                  <div
                    key={`quotes-${index}`}
                    className={styles["home__special-note-box"]}
                  >
                    <p
                      className={`${styles["home__special-note-text"]} font-ebGaramond`}
                    >
                      {item?.content ?? ""}
                    </p>
                  </div>
                ))}
            </Marquee>
          </div>

          {/* Second Marquee Row */}
          {messages.length > 1 && (
            <div style={{ height: "250px", maxWidth: "100vw", width: "100%" }}>
              <Marquee
                velocity={isMarqueePaused ? 0 : 40}
                direction="rtl"
                scatterRandomly={false}
                resetAfterTries={200}
                onInit={() => null}
                onFinish={() => null}
              >
                {messages
                  .filter((_, i) => i % 2 !== 0)
                  .map((item, index) => (
                    <div
                      key={`quotes-2-${index}`}
                      className={styles["home__special-note-box"]}
                    >
                      <p
                        className={`${styles["home__special-note-text"]} font-ebGaramond`}
                      >
                        {item?.content ?? ""}
                      </p>
                    </div>
                  ))}
              </Marquee>
            </div>
          )}

          {/* Special Note Button */}
          {/* {show && !!currentAccessToken && ( */}
          <div>
            <Dialog
              trigger={
                <div
                  className={`${styles["home__special-note__btn"]} font-ebGaramond capitalize`}
                >
                  Drop a special note
                </div>
              }
              open={open}
              onOpenChange={setOpen}
            >
              <MessageModal
                name={slugData?.eventBySlug?.name ?? ""}
                eventId={eventId}
                setOpen={setOpen}
              />
            </Dialog>
          </div>
          {/* )} */}
        </div>
      </div>
    </section>
  ) : null;
};

export default MarqueeComp;
